export default {
	SET_NAME: (state, name) => state.name = name,
	SET_EMAIL: (state, email) => state.email = email,
	SET_ID: (state, id) => state.id = id,
	SET_ROLE: (state, role) => state.role = role,
	SET_PROFILE_PICTURE: (state, url) => state.profilePicture = url
}